import { useMemo } from 'react'

import { useApiRequest } from '@tabeeb/shared/utils/hooks'

import { PredictionSetWithAIModelResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { getPredictionSet } from '../actions'

interface UsePredictionSetHookProps {
  id: number
  onError: (error: unknown) => void
}

interface UsePredictionSetHookState {
  loading: boolean
  predictionSet: PredictionSetWithAIModelResponse | null
}

export default ({ id, onError }: UsePredictionSetHookProps): UsePredictionSetHookState => {
  const payload = useMemo(() => ({ predictionSetId: id }), [id])

  const { loading, response: predictionSet } = useApiRequest({ request: getPredictionSet.request, payload, onError })

  return { loading, predictionSet }
}
